import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  open: {
    cursor: 'pointer',
    fontSize: '10px',
    color: palette['bronze-400'],
    ':hover': {
      color: palette['bronze-500'],
    },
  },
  infoWidget: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    flex: '1 0 0',
    alignSelf: 'stretch',
  },

  progressBarContainer: {
    width: '100%',
    height: '24px',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-2'],
    fontStyle: 'normal',
    fontFamily: fonts.din2014Regular,
    padding: '6px 24px',
  },
  total: {
    width: '100%',
    backgroundColor: palette['grey-50'],
  },
  recognized: (width: string) => ({
    width,
    backgroundColor: palette['grey-300'],
  }),
  unrecognized: (width: string) => ({
    width,
    backgroundColor: palette['grey-950'],
    color: palette['greyWhite'],
  }),
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
    fontFamily: fonts.din2014Regular,
    width: '66.6%',
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '1 0 0',
    gap: '16px',
    width: '856px',
  },
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    fontFamily: 'DIN 2014',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '12px',
  },
  accepted: {
    display: 'flex',
    padding: ' 6px 0px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3px',
    color: colors.tertiaryText,
  },
  notAccepted: {
    display: 'flex',
    padding: '6px 0px',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '3px',
    color: colors.tertiaryText,
  },
  unrecongnized: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    color: colors.tertiaryText,
    whiteSpace: 'pre-wrap',
  },
  unrecongnizedText: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  progressValue: {
    color: colors.ghostText,
  },
});
